import { useState } from "react";
import { toast } from "sonner";
import { Share2, Copy, Check } from "lucide-react";

const SHARE_TEXT =
  "I'm part of a bahoi /bə-HOY/ — a supportive community where time is the currency. Earn hours by volunteering, spend them on what neighbors offer.";

export default function ShareBahoiCard({ userName }) {
  const [copied, setCopied] = useState(false);
  const shareUrl = typeof window !== "undefined" ? `${window.location.origin}/about` : "";
  const greetingName = userName?.split(" ")[0];

  const handleShare = async () => {
    const payload = {
      title: "Bahoi · CauseMatch",
      text: SHARE_TEXT,
      url: shareUrl,
    };
    try {
      if (navigator.share && typeof navigator.canShare === "function" && navigator.canShare(payload)) {
        await navigator.share(payload);
        return;
      }
    } catch (e) {
      // user cancelled or share unavailable, fall through to copy
    }
    try {
      await navigator.clipboard.writeText(`${SHARE_TEXT} ${shareUrl}`);
      setCopied(true);
      toast.success("Copied to clipboard. Paste it anywhere.");
      setTimeout(() => setCopied(false), 2500);
    } catch (e) {
      toast.error("Couldn't copy. Try selecting the text manually.");
    }
  };

  return (
    <div
      data-testid="share-bahoi-card"
      className="card-soft p-6 md:p-7 relative overflow-hidden border-l-4"
      style={{ borderLeftColor: "var(--cm-primary)" }}
    >
      <div className="flex items-start gap-5 flex-wrap">
        <div className="flex-1 min-w-[220px]">
          <span className="overline text-[var(--cm-primary)]">Share Bahoi</span>
          <h3 className="font-display font-bold text-2xl md:text-3xl mt-1 tracking-tight">
            {greetingName ? `${greetingName}, you're part of a ` : "You're part of a "}
            <span className="italic">bahoi!</span>
          </h3>
          <p className="text-ink-soft mt-2 text-sm leading-relaxed max-w-md">
            <span className="font-semibold text-ink">Bahoi</span>{" "}
            <span className="italic">/ bə-HOY / noun</span> — a supportive community where time is
            the currency. Tell someone who'd love this.
          </p>
        </div>
        <div className="flex flex-col gap-2 min-w-[160px]">
          <button
            data-testid="share-bahoi-btn"
            onClick={handleShare}
            className="btn-primary inline-flex items-center justify-center gap-2 text-sm"
          >
            {copied ? <Check className="h-4 w-4" /> : <Share2 className="h-4 w-4" />}
            {copied ? "Copied" : "Share"}
          </button>
          <button
            data-testid="share-bahoi-copy-btn"
            onClick={async () => {
              try {
                await navigator.clipboard.writeText(`${SHARE_TEXT} ${shareUrl}`);
                setCopied(true);
                toast.success("Copied to clipboard.");
                setTimeout(() => setCopied(false), 2500);
              } catch (e) {
                toast.error("Couldn't copy.");
              }
            }}
            className="btn-outline inline-flex items-center justify-center gap-2 text-sm"
          >
            <Copy className="h-3.5 w-3.5" /> Copy text
          </button>
        </div>
      </div>
    </div>
  );
}
